import { DealRequest } from '@/app/api/types';

export type BranchAssignmentStatus =
  | 'waiting_assignment'
  | 'waiting_branch_approval'
  | null;

export const getBranchAssignmentStatus = (
  data: DealRequest
): BranchAssignmentStatus => {
  switch (data.branchStage) {
    case 'awaitingAssignment':
      return 'waiting_assignment';
    case 'awaitingBranchApproval':
      return 'waiting_branch_approval';
    default:
      return null;
  }
};
